export default {
  headerContent: {
    title: 'Groupama Sigorta İş Yeri Sigortası Hesaplama',
    slogan: "İş Yeri Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'İŞ YERİ SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Groupama Sigorta İş Yeri Sigortası',
    description: {
      title: 'Groupama Sigorta İş Yeri (Paket) Sigortası Nedir? ',
      content: [
        'İş yeri sigortası, işletmede oluşabilecek risklere karşı güvence sağlamaktadır. İşletmelerin karşılaşabilecekleri risklere karşı güvence sunan sigorta paketidir.',
        'İş yeri sigortası ile işletmenizi yangın, hırsızlık, deprem gibi birçok riske karşı güvence altına alarak büyük çaplı maddi kayıpları önleyebilirsiniz.'
      ]
    },
    subContent: {
      title: 'Groupama Sigorta İşyeri (Paket) Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph:
            'Groupama Sigorta teminatları ana ve ek olmak üzere 2’ye ayrılmaktadır.',
          subList: null
        },
        {
          paragraph: '<strong><em><u>Ana teminatlar;</u></em></strong>',
          subList: [
            'Alçıpan tavanların çökmesi',
            'Alternatif işyeri masrafları',
            'Arıza inşaat ve montaj işleri',
            'Dâhili su',
            'Duman',
            'Eksik sigorta koruma teminatı',
            'Elektrik hasarları',
            'Enkaz kaldırma',
            'Fırtına',
            'Fiziki zararlar',
            'Geçici adres nakli',
            'Grev, lokavt, terör',
            'Hava taşıtları çarpması',
            'Hukuksal koruma',
            'İçe çökme',
            'İş durması',
            'İşyeri yardım',
            'Kara taşıtları çarpması',
            'Raf ve vitrin devrilmesi',
            'Yakıt sızması',
            'Yangın söndürme masrafları',
            'Yangın ve infilak mali sorumluluk',
            'Yangın yıldırım infilak',
            'Zararın önlemesi için yapılan masraflar'
          ]
        },
        {
          paragraph: '<strong><em><u>Ek teminatlar:</u></em></strong>',
          subList: [
            'Deniz taşıtları çarpması',
            'Deprem ve yanardağ püskürmesi',
            'Dolu (Bina sigorta konusu var ise)',
            'Elektronik cihaz / Sabit cihaz',
            'Elektronik cihaz / Seyyar cihaz',
            'Emniyeti suistimal',
            'Ferdi kaza',
            'Gıda bozulması',
            'Hırsızlık',
            'İşveren sorumluluk ',
            'İzolasyon (Bina ya da dekorasyon sigorta konusu var ise)',
            'Kar ağırlığı',
            'Kira kaybı',
            'Makine kırılması / Mobil makine',
            'Makine kırılması/ Sabit makine',
            'Sel - Su baskını ',
            'Taşınan para',
            'Üçüncü şahıs mali mesuliyet',
            'Yeni değer esaslı',
            'Yer kayması'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'İş Yeri Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'İş Yeri Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'İş Yeri Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Groupama Sigorta İş Yeri Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
